import { Airport } from '@sd-portal/shared/airport';

export class LogbookApproach {
  logbookApproachId: number = 0; // PK
  airport: Airport;
  runway?: string;
  isEVS: boolean = false;
  // FKs
  logbookId: number = 0;
  approachTypeId?: number;
}
